import type { PiccoloError } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { FaSyncAlt } from 'react-icons/fa';
import { MdError } from 'react-icons/md';

interface Props {
  error: PiccoloError;
}

export const ErrorContent = (props: Props) => {
  return (
    <ChakraV3.Stack maxW='md' gap={6} alignSelf='center' align='center' textAlign='center'>
      <ChakraV3.Square size='16' rounded='2xl' bg='red.50'>
        <ChakraV3.Icon color='red.400' boxSize='10'>
          <MdError />
        </ChakraV3.Icon>
      </ChakraV3.Square>
      <ChakraV3.Text fontWeight='bold' fontSize='4xl'>
        {props.error.type}
      </ChakraV3.Text>
      <ChakraV3.Text fontSize='xl' fontWeight='semibold' color='gray.600'>
        {props.error.message}
      </ChakraV3.Text>
      <ChakraV3.Button onClick={() => window.location.reload()} w='full' variant='subtle' size='sm'>
        <FaSyncAlt />
        Refresh to try again
      </ChakraV3.Button>
    </ChakraV3.Stack>
  );
};
